module.exports = __webpack_public_path__ + "static/Study-bar-sketch-Desktop-e4eb77663f4375abc62cdbe79109ea8b.jpg";